import { useState } from 'react'

import { Box, Item } from '@factorialco/deprecated-design-system'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

function formatTaxRateName(amount?: number | null) {
  if (amount === null || amount === undefined) return ''
  return amount.toString() + '%'
}

interface TaxRatePercentageProps {
  percentage: number
}
interface TaxRateSelectorProps {
  currentTaxRate?: number | null
  taxRates?: TaxRatePercentageProps[]
  disabled: boolean
  onSelect: (taxRateAmount: string) => void
}

export const TaxRateSelector = ({
  currentTaxRate,
  taxRates = [],
  disabled,
  onSelect,
}: TaxRateSelectorProps) => {
  const [selectedTaxRateAmount, setSelectedTaxRateAmount] = useState<number | undefined | null>()
  const onSelectInterceptor = useUnsafeCallback(
    (item: Item) => {
      setSelectedTaxRateAmount(Number(item.value))
      onSelect(item.value.toString())
    },
    [onSelect]
  )

  useUnsafeMemo(() => {
    setSelectedTaxRateAmount(currentTaxRate)
  }, [currentTaxRate])

  const taxRateOptions = useUnsafeMemo(() => {
    return taxRates.map((o) => ({
      label: formatTaxRateName(o.percentage * 100),
      value: o.percentage * 100,
    }))
  }, [taxRates])

  return (
    <Box>
      <DropdownSearchBar
        name={taxRates && taxRates.length > 0 ? formatTaxRateName(selectedTaxRateAmount) : ''}
        data={taxRateOptions}
        label={i18n.t('expenses_v2.forms.fields.taxes.label_tax_rate')}
        labelNotFound={i18n.t('expenses_v2.forms.fields.taxes.label_tax_rate_not_found')}
        searchLabel={i18n.t('common.search')}
        sortLabel={i18n.t('common.name')}
        placeholder={i18n.t('expenses_v2.forms.fields.taxes.label_tax_rate')}
        selectLabel={i18n.t('expenses_v2.forms.fields.taxes.label_tax_rate_select')}
        disabled={disabled}
        autofocus={false}
        loading={false}
        onSelect={onSelectInterceptor}
      />
    </Box>
  )
}
